import { apiClient } from './index.js';
import { sanitizePostData } from '@/utils/index.js';

async function addAchievement({
  activityCVId,
  achievementTypeId,
  achievementLevelTypeId,
  achievementRoleTypeId,
  story,
  place,
  startDate,
  endDate,
}) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/AddAchievement',
    data: sanitizePostData({
      activityCVId,
      achievementTypeId,
      achievementLevelTypeId,
      achievementRoleTypeId,
      story,
      place,
      startDate,
      endDate,
    }),
    generalErrorsOnly: true,
  });
  return data;
}

async function updateAchievement({
  achievementId,
  achievementTypeId,
  achievementLevelTypeId,
  achievementRoleTypeId,
  story,
  place,
  startDate,
  endDate,
}) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/UpdateAchievement',
    data: sanitizePostData({
      achievementId,
      achievementTypeId,
      achievementLevelTypeId,
      achievementRoleTypeId,
      story,
      place,
      startDate,
      endDate,
    }),
    generalErrorsOnly: true,
  });
  return data;
}

async function removeAchievement({ achievementId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/RemoveAchievement',
    data: sanitizePostData({
      achievementId,
    }),
    generalErrorsOnly: true,
  });
  return data;
}

async function getAchievementTypeDescriptions({ activityId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Activity/GetAchievementTypeDescriptions',
    params: { ActivityId: activityId },
  });
  return data;
}

async function getAchievementLevelTypeDescriptions({ activityId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Activity/GetAchievementLevelTypeDescriptions',
    params: { ActivityId: activityId },
  });
  return data;
}

async function getAchievementRoleTypeDescriptions({ activityId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Activity/GetAchievementRoleTypeDescriptions',
    params: { ActivityId: activityId },
  });
  return data;
}

export {
  getAchievementTypeDescriptions,
  getAchievementLevelTypeDescriptions,
  getAchievementRoleTypeDescriptions,
  addAchievement,
  updateAchievement,
  removeAchievement,
};
